import { Fragment, useRef } from 'react';
import { Button } from 'antd';
import { useReactToPrint } from 'react-to-print';
import moment from "moment";

const LaboratoryLabel = ({ patient }) => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <Fragment>
      <div style={{ display: 'none' }}>
        <div ref={componentRef} className='print-label p-20'>
          <div>{patient?.patient_name}</div>
          <div>{patient?.document_number}</div>
          <div>{moment(patient?.birthdate).format('DD/MM/YYYY')}</div>
        </div>
      </div>
      <Button
        onClick={handlePrint}
        className="cmt-button outline secondary"
      >
        Imprimir etiqueta
      </Button>
    </Fragment>
  )
}

export default LaboratoryLabel;